import getApiClient from '@/plugins/api-client'

export default {
    load() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('home_start_nows')
            .then(result => {
                self.startNowItems = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },
    save(item) {
        const self = this,
            api = getApiClient(self.$store)

        self.errors[item.type] = []

        api.patch(item['@id'], {
            title: item.title,
            description: item.description
        }, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.load()
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[item.type][violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    }
}
